import { render, staticRenderFns } from "./task-column.vue?vue&type=template&id=98d5ee48&scoped=true&"
import script from "./task-column.vue?vue&type=script&lang=js&"
export * from "./task-column.vue?vue&type=script&lang=js&"
import style0 from "./task-column.vue?vue&type=style&index=0&id=98d5ee48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d5ee48",
  null
  
)

export default component.exports